import React, { useState } from 'react'
import { Card, Form, Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

const QuestAmountInfo = ({
  disabled = false,
  actualCost,
  discountCost,
  showDiscount = false,
  discountReason,
  total,
  deposit,
  selected,
  onSelectionChange,
  canPayRemaining = false,
  canPayFull = false,
  totalPaid,
  totalCost,
  quest,
  remainingBalance,
  eurRate,
  selectedPaymentMethod,
}) => {
  const [showCancellationPolicyModal, setShowCancellationPolicyModal] =
    useState(false)

  const handleSelect = (type) => {
    onSelectionChange(type)
  }

  const formatCurrency = (amount) => {
    if (selectedPaymentMethod === 'sepa' && eurRate) {
      const euroAmount = (amount * eurRate).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      const dollarAmount = Number(amount).toLocaleString()
      return `$${dollarAmount} | €${euroAmount}`
    }
    return `$${Number(amount).toLocaleString()}`
  }

  const renderCancellationPolicyLink = () => (
    <button
      type='button'
      className='cancellation-policy-link border-0 bg-transparent p-0 align-baseline'
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        setShowCancellationPolicyModal(true)
      }}>
      Cancellation Policy
    </button>
  )

  // Calculate the total amount to display based on selection
  const displayTotal = selected === 'deposit' ? deposit : total
  const displayOutstanding =
    !canPayFull && canPayRemaining ? remainingBalance : totalPaid

  return (
    <div className=''>
      {!canPayFull && canPayRemaining ? (
        <>
          <div className='p-24px bg-gray-300 p-3 rounded-3 mb-3'>
            <div className='mb-3 s6'>Secure your spot</div>
            <div
              className={`d-flex justify-content-between align-items-center ${
                showDiscount ? '' : 'mb-12px'
              }`}>
              <span className='s6b'>Total Amount</span>
              <span className='s6b'>
                {/* $ {Number(actualCost).toLocaleString()} */}
                {formatCurrency(actualCost)}
              </span>
            </div>
            {showDiscount && (
              <>
                <div className='d-flex justify-content-between align-items-center mt-12px'>
                  <span className='s6b text-saffron-700'>Discount</span>
                  <span className='s6b text-saffron-700'>
                    {/* - $ {Number(discountCost).toLocaleString()} */}
                    {`- ${formatCurrency(discountCost)}`}
                  </span>
                </div>
                <h6 className='mt-2px font-montserrat font-11px font-weight-500 text-black-shade ls-10'>
                  {discountReason}
                </h6>
              </>
            )}
            <div className='d-flex justify-content-between align-items-center mt-12px mb-16px'>
              <span className='s6b text-saffron-700'>Deposit</span>
              <span className='s6b text-saffron-700'>
                {/* - $ {Number(deposit).toLocaleString()} */}
                {`- ${formatCurrency(deposit)}`}
              </span>
            </div>
            {/* </span> */}
            <div className='card-border' />
            <div className='d-flex justify-content-between align-items-center mt-3'>
              <span className='s6a'>Remaining Amount</span>
              <span className='s6a'>{formatCurrency(displayOutstanding)}</span>
            </div>
            {/* <div className='mt-3 s11 text-black-70'>
              Begin your next steps on a journey of personal growth and
              transformative leadership.
            </div> */}
          </div>

          <Card className='p-3'>
            <Card.Body className='p-0'>
              <div className='s6a mb-12px'>Payment Options</div>
              <Form.Group className='mb-1 custom-radio'>
                <div className='d-flex align-items-center'>
                  <Form.Check
                    id='remaining-radio'
                    custom={true}
                    onChange={() => handleSelect('remaining')}
                    checked={true}
                    type='radio'
                    className={`${
                      disabled ? '' : 'cursor-pointer'
                    } d-flex align-items-center`}>
                    <Form.Check.Input
                      id='remaining-radio'
                      disabled={disabled}
                      onChange={() => handleSelect('remaining')}
                      checked={true}
                      type='radio'
                      className={`${
                        disabled ? '' : 'cursor-pointer'
                      } me-3 mt-0`}
                    />
                    <Form.Check.Label className={`s6b text-saffron-700`}>
                      Remaining Payment - {formatCurrency(displayOutstanding)}
                    </Form.Check.Label>
                  </Form.Check>
                </div>
              </Form.Group>
              <Form.Group className='mb-2 custom-radio'>
                <div className='d-flex align-items-center'>
                  <Form.Check
                    id='total-radio'
                    custom={true}
                    onChange={() => handleSelect('total')}
                    checked={selected === 'total'}
                    type='radio'
                    className={`${disabled ? '' : 'cursor-pointer'} d-none`}>
                    <Form.Check.Input
                      id='total-radio'
                      onChange={() => handleSelect('total')}
                      checked={selected === 'total'}
                      type='radio'
                      className={`${
                        disabled ? '' : 'cursor-pointer'
                      } me-3 mt-0`}
                    />
                  </Form.Check>
                </div>
              </Form.Group>
              <Form.Group className='mt-2 custom-checkbox'>
                <div className='d-flex justify-content-between align-items-center bg-gray-300 px-3 py-2 rounded-3'>
                  <Form.Check
                    id='total-checkbox'
                    custom={true}
                    onChange={() => handleSelect('total')}
                    checked={selected === 'total'}
                    type='checkbox'
                    className={`${
                      disabled ? '' : 'cursor-pointer'
                    } d-flex align-items-center`}>
                    <Form.Check.Label className='s6'>
                      Amount to pay now:
                    </Form.Check.Label>
                  </Form.Check>
                  <span className='s6'>
                    {formatCurrency(displayOutstanding)}
                  </span>
                </div>
              </Form.Group>
            </Card.Body>
          </Card>
        </>
      ) : (
        <>
          <div className='p-24px bg-gray-300 p-3 rounded-3 mb-3'>
            <div className='mb-3 s6'>Secure your spot</div>
            <div
              className={`d-flex justify-content-between align-items-center ${
                showDiscount ? '' : 'mb-12px'
              }`}>
              <span className='s6b'>Total Amount</span>
              <span className='s6b'>
                {/* $ {Number(actualCost).toLocaleString()} */}
                {formatCurrency(actualCost)}
              </span>
            </div>
            {showDiscount && (
              <>
                <div className='d-flex justify-content-between align-items-center mt-12px'>
                  <span className='s6b text-saffron-700'>Discount</span>
                  <span className='s6b text-saffron-700'>
                    {/* - $ {Number(discountCost).toLocaleString()} */}
                    {`- ${formatCurrency(discountCost)}`}
                  </span>
                </div>
                <h6 className='mb-3 mt-2px font-montserrat font-11px font-weight-500 text-black-shade ls-10'>
                  {discountReason}
                </h6>
              </>
            )}
            <div className='card-border' />
            <div className='d-flex justify-content-between align-items-center mt-3'>
              <span className='s6a'>Payment</span>
              <span className='s6a'>{formatCurrency(total)}</span>
            </div>
            {/* <div className='mt-3 s11 text-black-70'>
              Begin your next steps on a journey of personal growth and
              transformative leadership.
            </div> */}
          </div>

          <Card className='p-3'>
            <Card.Body className='p-0'>
              <div className='s6a mb-12px'>Payment Options</div>
              {deposit > 0 && (
                <Form.Group className='mb-3 custom-radio'>
                  <div className='d-flex align-items-center'>
                    <Form.Check
                      id='deposit-radio'
                      custom={true}
                      onChange={() => handleSelect('deposit')}
                      checked={selected === 'deposit'}
                      type='radio'
                      className={`${
                        disabled ? '' : 'cursor-pointer'
                      } d-flex align-items-center`}>
                      <Form.Check.Input
                        id='deposit-radio'
                        disabled={disabled}
                        onChange={() => handleSelect('deposit')}
                        checked={selected === 'deposit'}
                        type='radio'
                        className={`${
                          disabled ? '' : 'cursor-pointer'
                        } me-3 mt-0`}
                      />
                      <Form.Check.Label
                        className={`s6b ${
                          selected === 'deposit' ? 'text-saffron-700' : ''
                        }`}>
                        Deposit amount - {formatCurrency(deposit)}
                      </Form.Check.Label>
                    </Form.Check>
                    {/* <span className='s6b'>{formatCurrency(deposit)}</span> */}
                  </div>
                  <div className='payment-option-description ms-4 ps-2 mt-0.5 text-black-70'>
                    Your deposit reserves your spot. The remaining balance will
                    be automatically charged to this card 120 days before your
                    trip. See our {renderCancellationPolicyLink()} for details.
                  </div>
                </Form.Group>
              )}
              <Form.Group
                className={`${deposit > 0 ? 'mt-3' : ''} mb-1 custom-radio`}>
                <div className='d-flex align-items-center'>
                  <Form.Check
                    id='full-radio'
                    custom={true}
                    onChange={() => handleSelect('full')}
                    checked={selected === 'full'}
                    type='radio'
                    className={`${
                      disabled ? '' : 'cursor-pointer'
                    } d-flex align-items-center`}>
                    <Form.Check.Input
                      id='full-radio'
                      disabled={disabled}
                      onChange={() => handleSelect('full')}
                      checked={selected === 'full'}
                      type='radio'
                      className={`${
                        disabled ? '' : 'cursor-pointer'
                      } me-3 mt-0`}
                    />
                    <Form.Check.Label
                      className={`s6b ${
                        selected === 'full' ? 'text-saffron-700' : ''
                      }`}>
                      Full Payment - {formatCurrency(total)}
                    </Form.Check.Label>
                  </Form.Check>
                  {/* <span className='s6b'>{formatCurrency(total)}</span> */}
                </div>
                <div className='payment-option-description ms-4 ps-2 mt-0.5 text-black-70'>
                  Paying in full now completes your balance upfront. See our{' '}
                  {renderCancellationPolicyLink()} for details.
                </div>
              </Form.Group>
              <Form.Group className='mb-2 custom-radio'>
                <div className='d-flex align-items-center'>
                  <Form.Check
                    id='total-radio'
                    custom={true}
                    onChange={() => handleSelect('total')}
                    checked={selected === 'total'}
                    type='radio'
                    className={`${disabled ? '' : 'cursor-pointer'} d-none`}>
                    <Form.Check.Input
                      id='total-radio'
                      onChange={() => handleSelect('total')}
                      checked={selected === 'total'}
                      type='radio'
                      className={`${
                        disabled ? '' : 'cursor-pointer'
                      } me-3 mt-0`}
                    />
                  </Form.Check>
                  {/* {discount > 0 && (
                  <>
                    <Form.Check.Label className='s6b text-saffron-700'>
                      Discount
                    </Form.Check.Label>
                    <span className='s6b text-saffron-700'>
                      - $ {discount.toLocaleString()}
                    </span>
                  </>
                )} */}
                </div>
              </Form.Group>
              {/* <div className='card-border' /> */}
              <Form.Group className='mt-3 custom-checkbox'>
                <div className='d-flex justify-content-between align-items-center bg-gray-300 px-3 py-2 rounded-3'>
                  <Form.Check
                    id='total-checkbox'
                    custom={true}
                    onChange={() => handleSelect('total')}
                    checked={selected === 'total'}
                    type='checkbox'
                    className={`${
                      disabled ? '' : 'cursor-pointer'
                    } d-flex align-items-center ps-0`}>
                    <Form.Check.Label className='s6'>
                      Amount to pay now:
                    </Form.Check.Label>
                  </Form.Check>
                  <span className='s6'>{formatCurrency(displayTotal)}</span>
                </div>
              </Form.Group>
            </Card.Body>
          </Card>
        </>
      )}

      <Modal
        show={showCancellationPolicyModal}
        onHide={() => setShowCancellationPolicyModal(false)}
        centered
        className='payment-modal quest-payment-modal'
        size='lg'>
        <Modal.Header className='payment-modal-header d-flex justify-content-center'>
          <h3 className='payment-modal-title mb-0'>Cancellation Policy</h3>
        </Modal.Header>
        <Modal.Body className='payment-modal-body'>
          <ul className='mb-3 ps-3'>
            <li className='mb-2'>
              25% non-refundable deposit at booking, transferable to any Quest
              within 12 months
            </li>
            <li className='mb-2'>
              Remaining 75% auto-charged 120 days before departure (full payment
              at booking if booked within 120 days)
            </li>
            <li className='mb-2'>
              Deposit credit remains transferable regardless of cancellation
              timing
            </li>
          </ul>
          <p className='mb-2'>
            If you need to cancel your Quest, the following schedule applies to
            the total trip cost:
          </p>
          <ul className='mb-3 ps-3'>
            <li className='mb-2'>
              More than 120 days before departure: deposit forfeited; remaining
              balance not charged or refunded in full if already collected.
            </li>
            <li className='mb-2'>
              61 to 120 days before departure: 50% of total trip cost forfeited.
            </li>
            <li className='mb-2'>
              31 to 60 days before departure: 75% of total trip cost forfeited.
            </li>
            <li className='mb-2'>
              30 days or fewer before departure: 100% of total trip cost
              forfeited; no refund issued.
            </li>
            <li className='mb-2'>
              Your 25% deposit credit remains available for transfer to a future
              Quest regardless of when your cancellation occurs.
            </li>
          </ul>
          <p className='mb-0'>
            Any request for an exception to this schedule requires written
            approval from Abroad prior to processing.
          </p>
        </Modal.Body>
        <Modal.Footer className='border-0 d-flex justify-content-end pt-0'>
          <Button
            size='sm'
            onClick={() => setShowCancellationPolicyModal(false)}
            className='text-uppercase line-height-normal s9 border-radius-normal px-3 secondary-popup-button'>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <div className='mt-24px mb-16px s11 text-black-70'>
        Begin your next steps on a journey of personal growth and transformative
        leadership.
      </div> */}
    </div>
  )
}

export default QuestAmountInfo
